import React, { useState, useEffect } from 'react'
import { Card } from 'react-bootstrap'
import ClaimGroupWizardProgressBar from './ClaimGroupWizardProgressBar'
import CompanyDetailsStep from './CompanyDetailsStep'
import TeamStep from './Teamstep'
import ClassificationStep from './Classificationstep'
import QuestionnaireStep from './Questionnairestep'
import { CancelButton } from '@rd-web-markets/shared/dist/util/buttons'
import './CreateClaimGroupWizardPage.css'

const STEP_COMPANY  = 0
const STEP_TEAM     = 1
const STEP_CLASS    = 2
const STEP_QUEST    = 3

export default function CreateClaimGroupWizardPage({
  company,
  setCompany,
  managers,
  consultants,
  admins,
  claimTemplates,
  questionnaires,
  loading,
  handleSubmit,
  toggleForm,
}) {
  const [currentStep, setCurrentStep] = useState(STEP_COMPANY)
  const [claimTemplateTasks, setClaimTemplateTasks] = useState([]);

  const claimGroup = company.claim_group || {}

  const onCompanyFieldChange = (e) => {
    const { name, value } = e.target
    setCompany(prev => ({ ...prev, [name]: value }))
  }

  const onClaimGroupFieldChange = (e) => {
    const { name, value } = e.target
    setCompany(prev => ({
      ...prev,
      claim_group: { ...prev.claim_group, [name]: value }
    }))
  }

  useEffect(() => {
    if (claimTemplates?.length) {
      const defaultTemplate = claimTemplates[0]
      const tasks = []
      defaultTemplate.claim_template_categories.forEach(category => {
        category.claim_template_tasks.forEach(task => tasks.push({
          ...task,
          category_title: category.title,
          included: true
        }))
      })
      setClaimTemplateTasks(tasks)
    }
  }, [claimTemplates])

  const nextStep = () => setCurrentStep(s => s + 1)
  const prevStep = () => setCurrentStep(s => s - 1)
  const goToStep = (index) => setCurrentStep(index)

  const getQuestionnaireStatus = () => {
    const fields = [
      'has_overdue_taxes', 'has_staff_involved_not_on_payroll', 'accounts_provided',
      'tax_computations_provided', 'development_costs_capitalised', 'contracted_by_third_party',
      'received_grants_or_subsidies', 'reimburses_staff_expenses', 'purchased_company_cars',
      'has_patents', 'is_business_registered_in_northern_ireland',
    ]
    const answered = fields.filter(f => claimGroup[f] !== null && claimGroup[f] !== undefined)
    if (answered.length === 0) return 'not_started'
    if (answered.length === fields.length) return 'complete'
    return 'in_progress'
  }

  const handleFinalSubmit = async () => {
    await handleSubmit({ ...company, claim_template_tasks: claimTemplateTasks })
  }

  return (
    <>
      <Card className="mb-4">
        <Card.Header className="wizard-page__header">
          <div className="wizard-page__header-left">
            <span className="wizard-page__header-title">New Company — Claim Setup</span>
            {company.name && (
              <span className="wizard-page__header-context">{company.name}</span>
            )}
          </div>
          <CancelButton onClick={toggleForm} />
        </Card.Header>
      </Card>

      <Card className="mb-5 mt-5">
        <Card.Body>
          <ClaimGroupWizardProgressBar
            currentStep={currentStep}
            onStepClick={goToStep}
            questionnaireStatus={getQuestionnaireStatus()}
          />
        </Card.Body>
      </Card>


      <Card className="mb-5 mt-5">
      <Card.Body className="wizard-page__body">
          {currentStep === STEP_COMPANY && (
            <CompanyDetailsStep
              company={company}
              onChange={onCompanyFieldChange}
              setCompany={setCompany}
              onNext={nextStep}
            />
          )}

          {currentStep === STEP_TEAM && (
            <TeamStep
              claimGroup={claimGroup}
              company={company}
              managers={managers}
              admins={admins}
              consultants={consultants}
              onChange={onClaimGroupFieldChange}
              onNext={nextStep}
              onBack={prevStep}
            />
          )}

          {currentStep === STEP_CLASS && (
            <ClassificationStep
              claimGroup={claimGroup}
              onChange={onClaimGroupFieldChange}
              onNext={nextStep}
              onBack={prevStep}
              questionnaires={questionnaires}
            />
          )}

          {currentStep === STEP_QUEST && (
            <QuestionnaireStep
              claimGroup={claimGroup}
              onChange={onClaimGroupFieldChange}
              onBack={prevStep}
              onSubmit={handleFinalSubmit}
              loading={loading}
            />
          )}
        </Card.Body>
      </Card>
    </>
  )
}
